/**
 * Plateforme multi evenement e.labriquerie.net, (c) Mikaël FOURNY.
 * src/i18n/fr.platinium.entretiens.ts
 *
 * Messages du lot P5, contact via l’application, entretiens à date libre, évaluation, Mes entretiens côté candidat (chantier Platinium, cahier des charges
 * app/docs/CDC-PLATINIUM.md).
 *
 * Fichier créé VIDE et déjà branché par la vague 0 (fusionné dans fr.ts,
 * inscrit au garde-fou des sous-catalogues) : l'agent de ce lot n'écrit QUE
 * dans ce fichier. Les textes communs (statut, garde de l'espace, texte de
 * l'accord) sont dans fr.platinium.socle.ts : les réutiliser, ne pas les
 * redéfinir (le garde-fou refuse une clé définie deux fois).
 *
 * Règles : préfixe de clé « platinium.entretiens. » ; vouvoiement, apostrophes
 * typographiques, aucun tiret cadratin, aucun mot « atelier » en dur, aucun
 * nom, lieu ni type d'événement écrit en dur ({eventTypeDef}).
 *
 * Mikael - chef de projet - 2026-10-14
 */
export const messagesPlatiniumEntretiensFr: Record<string, string> = {
  // ── Commun ─────────────────────────────────────────────────────────────
  'platinium.entretiens.chargement': 'Chargement…',
  'platinium.entretiens.erreur':
    'Ces informations n’ont pas pu être chargées. Réessayez dans un instant.',
  'platinium.entretiens.annuler': 'Annuler',
  'platinium.entretiens.duree': '{minutes} min',
  'platinium.entretiens.ics': 'Ajouter à mon agenda (.ics)',
  'platinium.entretiens.mode.locaux': 'Dans nos locaux',
  'platinium.entretiens.mode.visio': 'En visioconférence',
  'platinium.entretiens.mode.telephone': 'Par téléphone',
  'platinium.entretiens.statut.inconnu': 'État inconnu',
  'platinium.entretiens.decision.a_revoir': 'À revoir',
  'platinium.entretiens.decision.proposition': 'Faire une proposition',
  'platinium.entretiens.decision.ne_pas_retenir': 'Ne pas retenir',
  'platinium.entretiens.decision.absent': 'Absent',

  // ── États, vus par l’entreprise ────────────────────────────────────────
  'platinium.entretiens.entreprise.statut.propose': 'En attente du candidat',
  'platinium.entretiens.entreprise.statut.accepte': 'Confirmé',
  'platinium.entretiens.entreprise.statut.refuse': 'Refusé',
  'platinium.entretiens.entreprise.statut.contre_propose': 'Autre moment proposé',
  'platinium.entretiens.entreprise.statut.expire': 'Sans réponse',
  'platinium.entretiens.entreprise.statut.annule': 'Annulé',
  'platinium.entretiens.entreprise.statut.termine': 'Terminé',
  'platinium.entretiens.entreprise.statut.absent': 'Absent',

  // ── États, vus par le candidat ─────────────────────────────────────────
  'platinium.entretiens.candidat.statut.propose': 'Votre réponse est attendue',
  'platinium.entretiens.candidat.statut.accepte': 'Confirmé',
  'platinium.entretiens.candidat.statut.refuse': 'Refusé',
  'platinium.entretiens.candidat.statut.contre_propose': 'En attente de l’entreprise',
  'platinium.entretiens.candidat.statut.expire': 'Délai dépassé',
  'platinium.entretiens.candidat.statut.annule': 'Annulé',
  'platinium.entretiens.candidat.statut.termine': 'Passé',
  'platinium.entretiens.candidat.statut.absent': 'Passé',

  // ── Refus du serveur, côté entreprise ──────────────────────────────────
  'platinium.entretiens.refus.dates_nombre': 'Proposez une à trois dates.',
  'platinium.entretiens.refus.date_invalide': 'Une date est illisible.',
  'platinium.entretiens.refus.date_passee': 'Une date proposée est déjà passée.',
  'platinium.entretiens.refus.date_hors_fenetre':
    'Une date tombe après la fermeture de votre espace recrutement.',
  'platinium.entretiens.refus.dates_en_double': 'Deux dates proposées sont identiques.',
  'platinium.entretiens.refus.lieu_requis': 'Indiquez le lieu de l’entretien.',
  'platinium.entretiens.refus.lien_invalide':
    'Indiquez un lien de visioconférence qui commence par https://.',
  'platinium.entretiens.refus.duree_invalide': 'Durée invalide.',
  'platinium.entretiens.refus.entretien_existe':
    'Un entretien est déjà en cours avec cette personne.',
  'platinium.entretiens.refus.accord_retire':
    'Cette personne a retiré son accord : ses informations ont été effacées de votre espace.',
  'platinium.entretiens.refus.debit_depasse':
    'Vous avez atteint le nombre de contacts autorisés par heure. Réessayez plus tard.',
  'platinium.entretiens.refus.recruteur_invalide': 'Ce recruteur ne peut pas mener cet entretien.',
  'platinium.entretiens.refus.not_allowed':
    'Cette personne ne peut pas être contactée par votre entreprise.',
  'platinium.entretiens.refus.no_cv': 'Cette personne n’a plus de CV actif.',
  'platinium.entretiens.refus.minor_protected':
    'Les mineurs sans accord parental ne peuvent pas être contactés.',
  'platinium.entretiens.refus.fenetre_fermee': 'Votre espace recrutement n’est pas ouvert en ce moment.',
  'platinium.entretiens.refus.statut_invalide':
    'Cette action n’est plus possible sur cet entretien.',
  'platinium.entretiens.refus.pas_encore': 'L’heure de l’entretien n’est pas encore passée.',
  'platinium.entretiens.refus.note_invalide': 'Les notes vont de 1 à 5.',
  'platinium.entretiens.refus.critere_inconnu':
    'Un critère d’évaluation n’est plus proposé. Rechargez la page.',
  'platinium.entretiens.refus.message_vide': 'Indiquez un objet et un message.',
  'platinium.entretiens.refus.envoi_echec':
    'Le courriel n’a pas pu partir. Le message est enregistré en échec ; réessayez plus tard.',
  'platinium.entretiens.refus.modele_incomplet': 'Indiquez un nom, un objet et un texte.',
  'platinium.entretiens.refus.inconnu': 'La demande n’a pas abouti. Réessayez.',

  // ── Onglet Agenda ──────────────────────────────────────────────────────
  'platinium.entretiens.agenda.titre': 'Vos entretiens',
  'platinium.entretiens.agenda.intro.mere':
    'Les entretiens de tous les recruteurs de votre entreprise. Proposez un entretien depuis la fiche d’une personne de votre vivier.',
  'platinium.entretiens.agenda.intro.recruteur':
    'Les entretiens que vous menez. Proposez un entretien depuis la fiche d’une personne de votre vivier.',
  'platinium.entretiens.agenda.filtre': 'Recruteur',
  'platinium.entretiens.agenda.filtre.tous': 'Tous les recruteurs',
  'platinium.entretiens.agenda.vide': 'Aucun entretien pour le moment.',
  'platinium.entretiens.agenda.aTraiter': 'À traiter ({n})',
  'platinium.entretiens.agenda.aVenir': 'À venir',
  'platinium.entretiens.agenda.rappels':
    'Un rappel part la veille, puis {minutes} min avant l’heure, au candidat et au recruteur.',
  'platinium.entretiens.agenda.semaine': 'Semaine du {date}',
  'platinium.entretiens.agenda.enAttente': 'En attente de réponse',
  'platinium.entretiens.agenda.historique': 'Historique ({n})',

  // ── Carte et fiche d’un entretien ──────────────────────────────────────
  'platinium.entretiens.carte.efface': 'Personne effacée (accord retiré)',
  'platinium.entretiens.carte.dates': '{n} dates proposées',
  'platinium.entretiens.carte.moi': 'vous',
  'platinium.entretiens.carte.aMarquer': 'L’heure est passée : indiquez si l’entretien a eu lieu.',
  'platinium.entretiens.fiche.date': 'Date',
  'platinium.entretiens.fiche.dateProposee': 'Date proposée {n}',
  'platinium.entretiens.fiche.mode': 'Mode',
  'platinium.entretiens.fiche.lieu': 'Lieu',
  'platinium.entretiens.fiche.lien': 'Lien',
  'platinium.entretiens.fiche.telephone': 'Téléphone',
  'platinium.entretiens.fiche.recruteur': 'Recruteur',
  'platinium.entretiens.fiche.limite': 'Réponse attendue avant le',
  'platinium.entretiens.fiche.votreMessage': 'Votre message',
  'platinium.entretiens.fiche.motCandidat': 'Le mot du candidat',
  'platinium.entretiens.fiche.contre': 'Le moment proposé par le candidat',
  'platinium.entretiens.fiche.reproposer': 'Proposer de nouvelles dates',
  'platinium.entretiens.fiche.termine': 'L’entretien a eu lieu',
  'platinium.entretiens.fiche.absent': 'Le candidat était absent',
  'platinium.entretiens.fiche.marquerApres':
    'Vous pourrez indiquer si l’entretien a eu lieu une fois l’heure passée.',
  'platinium.entretiens.fiche.annuler': 'Annuler l’entretien',
  'platinium.entretiens.fiche.annuler.confirmer':
    'Annuler cet entretien ? Le candidat en sera prévenu.',
  'platinium.entretiens.fiche.annule.ok': 'L’entretien est annulé, le candidat est prévenu.',

  // ── Proposer un entretien ──────────────────────────────────────────────
  'platinium.entretiens.proposer.titre': 'Proposer un entretien',
  'platinium.entretiens.proposer.titre.nouvelle': 'Proposer de nouvelles dates',
  'platinium.entretiens.proposer.dates': 'Dates et heures',
  'platinium.entretiens.proposer.dates.aide':
    'Une à trois possibilités : le candidat choisira celle qui lui convient.',
  'platinium.entretiens.proposer.date': 'Possibilité {n}',
  'platinium.entretiens.proposer.date.ajouter': 'Ajouter une possibilité',
  'platinium.entretiens.proposer.date.retirer': 'Retirer la possibilité {n}',
  'platinium.entretiens.proposer.mode': 'Mode',
  'platinium.entretiens.proposer.lieu': 'Lieu de l’entretien',
  'platinium.entretiens.proposer.lien': 'Lien de la visioconférence',
  'platinium.entretiens.proposer.lieu.aide': 'Le candidat le verra une fois l’entretien accepté.',
  'platinium.entretiens.proposer.duree': 'Durée prévue',
  'platinium.entretiens.proposer.recruteur': 'Entretien mené par',
  'platinium.entretiens.proposer.recruteur.moi': 'Moi',
  'platinium.entretiens.proposer.message': 'Message au candidat (facultatif)',
  'platinium.entretiens.proposer.envoyer': 'Envoyer la proposition',
  'platinium.entretiens.proposer.ok': 'Proposition envoyée au candidat.',
  'platinium.entretiens.proposer.ok.nouvelle': 'Nouvelles dates envoyées au candidat.',

  // ── Évaluation, notes, résumé ──────────────────────────────────────────
  'platinium.entretiens.evaluation.titre': 'Évaluation',
  'platinium.entretiens.evaluation.interne':
    'Réservée à votre entreprise : le candidat ne la voit jamais.',
  'platinium.entretiens.evaluation.note': 'Note globale',
  'platinium.entretiens.evaluation.surCinq': '{n} sur 5',
  'platinium.entretiens.evaluation.nonNote': 'Non noté',
  'platinium.entretiens.evaluation.decision': 'Décision',
  'platinium.entretiens.evaluation.decision.aucune': 'Pas encore décidé',
  'platinium.entretiens.evaluation.par': 'Évaluation de {nom}, le {date}.',
  'platinium.entretiens.evaluation.enregistrer': 'Enregistrer l’évaluation',
  'platinium.entretiens.evaluation.ok': 'Évaluation enregistrée.',
  'platinium.entretiens.notes.titre': 'Notes',
  'platinium.entretiens.notes.vide': 'Aucune note pour le moment.',
  'platinium.entretiens.notes.ajouter': 'Ajouter une note',
  'platinium.entretiens.notes.aide': 'Une note est datée et signée ; elle ne se modifie pas.',
  'platinium.entretiens.notes.enregistrer': 'Ajouter la note',
  'platinium.entretiens.resume.demander': 'Résumer les notes',
  'platinium.entretiens.resume.indisponible': 'Le résumé automatique n’est pas disponible.',

  // ── Messages et modèles ────────────────────────────────────────────────
  'platinium.entretiens.echanges.titre': 'Échanges',
  'platinium.entretiens.echanges.vide': 'Aucun message envoyé à cette personne.',
  'platinium.entretiens.echanges.ecrire': 'Écrire via l’application',
  'platinium.entretiens.echanges.statut.en_attente': 'en cours d’envoi',
  'platinium.entretiens.echanges.statut.envoye': 'envoyé',
  'platinium.entretiens.echanges.statut.echec': 'non parti',
  'platinium.entretiens.message.titre': 'Écrire au candidat',
  'platinium.entretiens.message.modele': 'Modèle',
  'platinium.entretiens.message.modele.aucun': 'Sans modèle',
  'platinium.entretiens.message.sujet': 'Objet',
  'platinium.entretiens.message.corps': 'Message',
  'platinium.entretiens.message.variables':
    'Remplacés à l’envoi : {prenom} par le prénom du candidat, {entreprise}, {recruteur} par votre nom, {evenement}.',
  'platinium.entretiens.message.signature':
    'Le message part signé de votre nom et de celui de votre entreprise. La réponse du candidat arrivera dans votre boîte aux lettres.',
  'platinium.entretiens.message.contacte':
    'Passer la personne à l’étape « Contacté » de votre vivier',
  'platinium.entretiens.message.envoyer': 'Envoyer',
  // 2026-10-14, lot P6 : l'aide IA facultative à la rédaction.
  // Mikael - chef de projet - 2026-10-14
  'platinium.entretiens.message.assist.bouton': 'Rédiger avec l’assistance',
  'platinium.entretiens.message.assist.intention': 'Ce que vous voulez dire',
  'platinium.entretiens.message.assist.aide':
    'Quelques mots suffisent. L’assistance propose un objet et un texte, que vous relisez et modifiez avant d’envoyer. Le nom et les coordonnées du candidat ne lui sont jamais transmis.',
  'platinium.entretiens.message.assist.proposer': 'Proposer un texte',
  'platinium.entretiens.message.assist.encours': 'Rédaction en cours…',
  'platinium.entretiens.message.assist.ok': 'Texte proposé dans le formulaire. Relisez-le avant d’envoyer.',
  'platinium.entretiens.message.assist.indisponible':
    'L’assistance à la rédaction n’est pas disponible. Vous pouvez écrire votre message vous-même.',
  'platinium.entretiens.message.assist.vide': 'Indiquez en quelques mots ce que vous voulez dire.',
  'platinium.entretiens.message.ok': 'Message envoyé.',
  'platinium.entretiens.message.ok.contacte':
    'Message envoyé. La personne est passée à « Contacté ».',
  'platinium.entretiens.modeles.titre': 'Modèles de messages',
  'platinium.entretiens.modeles.intro':
    'Adaptez les modèles proposés à vos recruteurs, ou créez les vôtres.',
  'platinium.entretiens.modeles.introRecruteur':
    'Les modèles proposés par votre entreprise. Seul le compte principal les modifie.',
  'platinium.entretiens.modeles.origine.defaut': 'Proposé',
  'platinium.entretiens.modeles.origine.organisation': 'De l’organisation',
  'platinium.entretiens.modeles.origine.entreprise': 'Le vôtre',
  'platinium.entretiens.modeles.inactif': 'Désactivé',
  'platinium.entretiens.modeles.modifier': 'Modifier',
  'platinium.entretiens.modeles.desactiver': 'Désactiver',
  'platinium.entretiens.modeles.reactiver': 'Réactiver',
  'platinium.entretiens.modeles.nouveau': 'Nouveau modèle',
  'platinium.entretiens.modeles.formulaire': 'Modèle de message',
  'platinium.entretiens.modeles.nom': 'Nom du modèle',
  'platinium.entretiens.modeles.enregistrer': 'Enregistrer le modèle',
  'platinium.entretiens.modeles.ok': 'Modèle enregistré.',

  // ── Emplacement de la fiche du vivier ──────────────────────────────────
  'platinium.entretiens.emplacement.titre': 'Entretiens',
  'platinium.entretiens.emplacement.vide': 'Aucun entretien avec cette personne.',
  'platinium.entretiens.emplacement.proposer': 'Proposer un entretien',
  'platinium.entretiens.emplacement.enCours':
    'Un entretien est en cours : une nouvelle proposition sera possible une fois celui-ci terminé, refusé ou annulé.',

  // ── Côté candidat : Mes entretiens Platinium ───────────────────────────
  'platinium.entretiens.lien':
    '{n, plural, =0 {Mes entretiens Platinium} one {Mes entretiens Platinium : # proposition à traiter} other {Mes entretiens Platinium : # propositions à traiter}}',
  'platinium.entretiens.mes.retour': 'Mes entretiens',
  'platinium.entretiens.mes.titre': 'Mes entretiens Platinium',
  'platinium.entretiens.mes.intro':
    'Les entretiens que des entreprises Platinium vous proposent après {eventTypeDef}, parce que vous avez accepté qu’elles vous contactent.',
  'platinium.entretiens.mes.indisponible':
    'Les entretiens Platinium ne sont pas proposés en ce moment.',
  'platinium.entretiens.mes.ferme':
    'Les entretiens Platinium sont fermés : vous ne pouvez plus y répondre.',
  'platinium.entretiens.mes.sansAccord':
    'Vous avez retiré votre accord Platinium : les entreprises ne peuvent plus vous proposer d’entretien.',
  'platinium.entretiens.mes.vide.titre': 'Aucun entretien Platinium',
  'platinium.entretiens.mes.vide.texte':
    'Quand une entreprise vous proposera un entretien, vous le trouverez ici et vous recevrez un courriel.',
  'platinium.entretiens.mes.vide.sansAccord':
    'Pour que les entreprises Platinium puissent vous proposer un entretien, donnez votre accord dans Mon profil.',
  'platinium.entretiens.mes.propositions': 'Propositions à traiter',
  'platinium.entretiens.mes.confirmes': 'Entretiens confirmés',
  'platinium.entretiens.mes.enAttente': 'En attente de l’entreprise',
  'platinium.entretiens.mes.historique': 'Historique ({n})',
  'platinium.entretiens.mes.avec': 'avec {recruteur}',
  'platinium.entretiens.mes.limite': 'réponse attendue avant le {date}',
  'platinium.entretiens.mes.messageEntreprise': 'Message de l’entreprise',
  'platinium.entretiens.mes.choisirDate': 'Choisissez une date',
  'platinium.entretiens.mes.mot': 'Un mot pour l’entreprise (facultatif)',
  'platinium.entretiens.mes.accepter': 'Accepter cette date',
  'platinium.entretiens.mes.refuser': 'Refuser',
  'platinium.entretiens.mes.refuser.confirmer': 'Refuser l’entretien proposé par {entreprise} ?',
  'platinium.entretiens.mes.contre': 'Proposer un autre moment',
  'platinium.entretiens.mes.contre.libelle': 'Quel moment vous conviendrait ?',
  'platinium.entretiens.mes.contre.aide':
    'Par exemple : « le mardi ou le jeudi après-midi ». L’entreprise vous fera une nouvelle proposition.',
  'platinium.entretiens.mes.contre.envoyer': 'Envoyer ma proposition',
  'platinium.entretiens.mes.votreProposition': 'Votre proposition',
  'platinium.entretiens.mes.rappels':
    'Vous recevrez un rappel la veille, puis {minutes} min avant l’heure.',
  'platinium.entretiens.mes.telephone': 'Le recruteur vous appellera à l’heure prévue.',
  'platinium.entretiens.mes.annuler': 'Annuler l’entretien',
  'platinium.entretiens.mes.annuler.confirmer':
    'Annuler votre entretien avec {entreprise} ? L’entreprise en sera prévenue.',
  'platinium.entretiens.mes.motif.candidat': 'Vous l’avez annulé.',
  'platinium.entretiens.mes.motif.entreprise': 'L’entreprise l’a annulé.',
  'platinium.entretiens.mes.motif.retrait_accord': 'Annulé quand vous avez retiré votre accord.',
  'platinium.entretiens.mes.motif.cv_efface': 'Annulé : votre CV n’est plus conservé.',
  'platinium.entretiens.mes.motif.fermeture': 'Annulé à la fermeture des entretiens Platinium.',
  'platinium.entretiens.mes.ok.accepter':
    'C’est confirmé : l’entreprise est prévenue et un courriel vous a été envoyé.',
  'platinium.entretiens.mes.ok.refuser': 'Votre réponse est envoyée à l’entreprise.',
  'platinium.entretiens.mes.ok.contre': 'Votre proposition est envoyée à l’entreprise.',
  'platinium.entretiens.mes.ok.annuler': 'L’entretien est annulé, l’entreprise est prévenue.',
  'platinium.entretiens.mes.refus.fenetre_fermee': 'Les entretiens Platinium ne sont plus ouverts.',
  'platinium.entretiens.mes.refus.module_indisponible':
    'Les entretiens Platinium ne sont pas proposés en ce moment.',
  'platinium.entretiens.mes.refus.accord_retire': 'Vous avez retiré votre accord Platinium.',
  'platinium.entretiens.mes.refus.statut_invalide': 'Cet entretien n’attend plus votre réponse.',
  'platinium.entretiens.mes.refus.entretien_expire': 'Le délai de réponse est dépassé.',
  'platinium.entretiens.mes.refus.date_inconnue': 'Choisissez une des dates proposées.',
  'platinium.entretiens.mes.refus.date_passee': 'Cette date est déjà passée.',
  'platinium.entretiens.mes.refus.contre_proposition_vide':
    'Indiquez le moment qui vous conviendrait.',
  'platinium.entretiens.mes.refus.entreprise_indisponible':
    'Cette entreprise n’a plus accès aux entretiens Platinium.',
  'platinium.entretiens.mes.refus.inconnu': 'Votre réponse n’a pas pu être envoyée. Réessayez.',
};
